// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"883adc60","384":"3dd3e535","470":"0c678828","494":"957d0fc8","567":"7b9a2490","580":"43d3c7f6","589":"6fad8d07","652":"3dd3e535","836":"14e377f1","895":"0c678828","925":"56dca937","964":"cb379fba"}[chunkId] + ".chunk.css";
};